// components/SelectUserTypeStep.tsx
import React from "react";
import { Button } from "../../../../../design/button";
import OnboardingContainer from "../../../components/OnboardingContainer";
import { Intake } from "../../../../../models/Intake";
import { OnboardingUserForm } from "../../../../../models/OnboardingUserForm";

interface OnboardingUserTypeStepProps {
  formData: OnboardingUserForm;
  setFormData: React.Dispatch<React.SetStateAction<OnboardingUserForm>>;
  onBack: () => void;
  onStepComplete: () => void;
}

const OnboardingUserTypeStep: React.FC<OnboardingUserTypeStepProps> = ({
  formData,
  setFormData,
  onBack,
  onStepComplete,
}) => {
  return (
    <OnboardingContainer
      title="Welcome to CaseTime!"
      subtitle="Let's get you started."
    >
      <>
        <p className="mb-6 text-gray-700">
          Are you here to manage your own case, or to offer professional
          services?
        </p>

        <div className="flex flex-col gap-6">
          <Button
            className="w-full"
            onClick={() => {
              setFormData({ ...formData, type: "user" });
              onStepComplete();
            }}
          >
            I'm here to manage my case
          </Button>

          <Button
            className="w-full"
            onClick={() => {
              setFormData({ ...formData, type: "professional" });
              onStepComplete();
            }}
          >
            I'm a professional offering services
          </Button>
        </div>
      </>
    </OnboardingContainer>
  );
};

export default OnboardingUserTypeStep;
